import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  Box,
  useMediaQuery,
  Avatar,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as ScrollLink } from 'react-scroll';
import logo from '../assets/logo.png'; // ✅ Your logo

const navItems = ['Home', 'About', 'Courses', 'Services', 'Achievements', 'Testimonials'];

function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const toggleDrawer = (open) => () => setDrawerOpen(open);

  const handleLogin = () => setIsLoggedIn(true);
  const handleLogout = () => setIsLoggedIn(false);

  const drawer = (
    <Box
      sx={{
        width: 260,
        backgroundColor: '#ffffff',
        height: '100%',
        fontFamily: 'Poppins, sans-serif',
        pt: 3,
        px: 3,
      }}
      onClick={toggleDrawer(false)}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 700,
          fontSize: '1.3rem',
          color: '#0c1e3c',
          mb: 2,
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        SPARK AI EDUTECH Solutions
      </Typography>

      {navItems.map((item) => (
        <ScrollLink
          key={item}
          to={item.toLowerCase()}
          smooth={true}
          duration={600}
          offset={-70}
          style={{ width: '100%', textDecoration: 'none' }}
        >
          <Button
            fullWidth
            variant="outlined"
            sx={{
              my: 0.8,
              fontWeight: 'bold',
              textTransform: 'none',
              borderRadius: '30px',
              color: '#0c1e3c',
              borderColor: '#0c1e3c',
              fontFamily: 'Poppins, sans-serif',
              '&:hover': {
                backgroundColor: 'rgba(12,30,60,0.08)',
              },
            }}
          >
            {item}
          </Button>
        </ScrollLink>
      ))}

      {/* 📞 Call Button */}
      <a href="tel:+919949337308" style={{ textDecoration: 'none', width: '100%' }}>
        <Button
          variant="contained"
          fullWidth
          sx={{
            mt: 2,
            backgroundColor: '#ffcb05',
            color: '#0c1e3c',
            fontWeight: 'bold',
            borderRadius: '30px',
            textTransform: 'none',
            fontFamily: 'Poppins, sans-serif',
            '&:hover': {
              backgroundColor: '#f7be03',
            },
          }}
        >
          📞 Call Us Now
        </Button>
      </a>

      {/* 🔐 Login / Logout */}
      <Button
        onClick={isLoggedIn ? handleLogout : handleLogin}
        fullWidth
        sx={{
          mt: 2,
          backgroundColor: isLoggedIn ? '#e53935' : '#1976d2',
          color: '#fff',
          fontWeight: 'bold',
          borderRadius: '30px',
          textTransform: 'none',
          fontFamily: 'Poppins, sans-serif',
          '&:hover': {
            backgroundColor: isLoggedIn ? '#d32f2f' : '#1565c0',
          },
        }}
      >
        {isLoggedIn ? 'Logout' : 'Login'}
      </Button>
    </Box>
  );

  return (
    <AppBar
      position="sticky"
      elevation={6}
      sx={{
        background: 'rgba(12, 30, 60, 0.95)',
        backdropFilter: 'blur(6px)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
        py: 1,
        px: 2,
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          maxWidth: '1400px',
          width: '100%',
          mx: 'auto',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        {/* 🔹 Logo */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pl: 2 }}>
          <Avatar
            src={logo}
            alt="logo"
            sx={{
              width: 44,
              height: 44,
              borderRadius: '8px',
              backgroundColor: '#fff',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontSize: '1.5rem',
              color: '#ffffff',
              fontFamily: 'Poppins, sans-serif',
            }}
          >
            SPARK AI EDUTECH
          </Typography>
        </Box>

        {/* 🔹 Desktop Nav */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {isMobile ? (
            <>
              <IconButton
                onClick={toggleDrawer(true)}
                sx={{
                  ml: 1,
                  backgroundColor: '#ffcb05',
                  borderRadius: '50%',
                  p: 1.2,
                  '&:hover': {
                    backgroundColor: '#f7be03',
                  },
                }}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{ sx: { boxShadow: 4 } }}
              >
                {drawer}
              </Drawer>
            </>
          ) : (
            <>
              {navItems.map((item) => (
                <ScrollLink
                  key={item}
                  to={item.toLowerCase()}
                  smooth={true}
                  duration={600}
                  offset={-70}
                  style={{
                    margin: '0 12px',
                    cursor: 'pointer',
                    fontWeight: 500,
                    fontSize: '1rem',
                    color: '#ffffff',
                    fontFamily: 'Poppins, sans-serif',
                    textDecoration: 'none',
                  }}
                >
                  {item}
                </ScrollLink>
              ))}
              <a href="tel:+919949337308" style={{ textDecoration: 'none' }}>
                <Button
                  variant="contained"
                  sx={{
                    ml: 3,
                    backgroundColor: '#ffcb05',
                    color: '#0c1e3c',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    borderRadius: '30px',
                    px: 3,
                    py: 1,
                    fontSize: '0.95rem',
                    fontFamily: 'Poppins, sans-serif',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    '&:hover': {
                      backgroundColor: '#f7be03',
                    },
                  }}
                >
                  📞 Get Started
                </Button>
              </a>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
